// Buyurtma holatlari — admin panelning YAGONA holat → o'zbekcha yorliq / rang xaritasi.
// Jadval, filtr va tafsilot shu yerdan o'qiydi. Kalitlar backend `tasks.status` qiymatlari
// (services/orderStatus.js) + eski ma'lumotdagi sinonimlar. Test bazasidagi DISTINCT:
// published, accepted, finished; kod yana onTheWay, started, awaiting_confirmation,
// completed, disputed, cancelled yozadi.

const LABEL = {
  published: "E'lon qilingan",
  pending: 'Kutilmoqda',
  accepted: 'Qabul qilindi',
  rejected: 'Rad etildi',
  active: 'Faol',
  in_progress: 'Jarayonda',
  assigned: 'Biriktirilgan',
  onTheWay: "Yo'lda",
  started: 'Ish boshlangan',
  awaiting_confirmation: 'Tasdiq kutilmoqda',
  disputed: "E'tiroz bildirilgan",
  completed: 'Yakunlangan',
  finished: 'Yakunlangan',
  done: 'Yakunlangan',
  cancelled: 'Bekor qilingan',
  canceled: 'Bekor qilingan',
  bekor: 'Bekor qilingan',
};

const TONE = {
  published: 'amber',
  pending: 'amber',
  active: 'neutral',
  in_progress: 'neutral',
  assigned: 'neutral',
  accepted: 'neutral',
  onTheWay: 'neutral',
  started: 'neutral',
  awaiting_confirmation: 'amber',
  disputed: 'red',
  completed: 'green',
  finished: 'green',
  done: 'green',
  rejected: 'red',
  cancelled: 'red',
  canceled: 'red',
  bekor: 'red',
};

// 'awaiting-confirmation' / 'awaitingconfirmation' kabi variantlarni kanonik kalitga keltiradi.
function key(status) {
  const raw = String(status == null ? '' : status).trim();
  if (LABEL[raw]) return raw;
  const flat = raw.toLowerCase().replace(/[\s_-]+/g, '');
  if (flat === 'awaitingconfirmation') return 'awaiting_confirmation';
  if (flat === 'ontheway') return 'onTheWay';
  return raw;
}

// Noma'lum qiymat uchun xom qiymat qaytariladi (bo'sh bo'lsa '—').
export function orderStatusLabel(status) {
  const k = key(status);
  return LABEL[k] || (k || '—');
}

export function orderStatusTone(status) {
  return TONE[key(status)] || 'gray';
}

// Holat filtri: [qiymat, yorliq]. Qiymat backend `?status=` ga ketadi ('' = hammasi).
// 'active' = accepted + onTheWay + started (backend guruhi).
export const ORDER_STATUS_FILTERS = [
  ['', 'Hammasi'],
  ['published', LABEL.published],
  ['active', LABEL.active],
  ['accepted', LABEL.accepted],
  ['onTheWay', LABEL.onTheWay],
  ['started', LABEL.started],
  ['awaiting_confirmation', LABEL.awaiting_confirmation],
  ['disputed', LABEL.disputed],
  ['completed', LABEL.completed],
  ['cancelled', LABEL.cancelled],
];
